export default "__VITE_ASSET__BLzf8UGs__"